export class UserRoles {
	Id: number;
	Name: string;
	IsEmployeeRole: boolean;
	Description: string;

	name: string;
}